module.exports = __webpack_public_path__ + "static/media/nyeBig.c1897588.gif";